"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions.js");

var initialState = (0, _immutable.fromJS)({
  isUserFromSignup: false
});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchOptInStatusActionTypes.SUCCESS, function (state, action) {
  var status = action.payload.data;
  return state.set('isUserFromSignup', status.fromSignup);
}), initialState);

exports.default = _default;
module.exports = exports.default;